import React, {Dispatch, ReactNode, SetStateAction} from 'react';
import {useSelector} from 'react-redux';

import Table, {SetOrderByType} from 'shared/ui/Table/Table';
import {getDomainIncidentColumns} from 'features/domain/lib/domainIncidentHelper';
import DomainIncidentRow from 'features/domain/ui/DomainIncident/DomainIncidentRow/DomainIncidentRow';
import IPagination from 'shared/api/model/IPagination';
import IOrderBy from 'shared/model/IOrderBy';
import IDomainIncident from 'features/domain/model/DomainIncident/IDomainIncident';
import {userSelector} from 'entities/user';

interface IDomainIncidentsProps {
    pagination?: IPagination<IDomainIncident>,
    isLoading: boolean,
    hidePagination?: boolean,
    hideDomain?: boolean,
    sort?: IOrderBy,
    setSort?: SetOrderByType,
    setPage?: Dispatch<SetStateAction<number>>,
    emptyStateComponent?: ReactNode,
    plug?: ReactNode,
}

const DomainIncidents: React.FC<IDomainIncidentsProps> = ({
    pagination,
    isLoading,
    hidePagination = false,
    hideDomain = false,
    sort,
    setSort,
    setPage,
    emptyStateComponent = true,
    plug,
}) => {
    const user = useSelector(userSelector);

    return (
        <>
            <Table
                columns={getDomainIncidentColumns(hideDomain)}
                items={pagination?.items}
                rowFactory={item =>
                    <DomainIncidentRow
                        key={item.id}
                        item={item}
                        tzString={user?.timezone}
                        hideDomain={hideDomain}
                    />
                }
                isLoading={isLoading}
                pagination={pagination && !hidePagination ? pagination : undefined}
                sort={sort}
                setSort={setSort}
                setPage={setPage}
                emptyStateComponent={emptyStateComponent}
            />
            {plug}
        </>
    );
};

export default DomainIncidents;
